export enum SidenavCountTypeEnum {
  ACTION_REQUIRED_USERS = 'ACTION_REQUIRED_USERS',
  ACTION_REQUIRED_JOBS = 'ACTION_REQUIRED_JOBS',
  ACTION_REQUIRED_EMPLOYMENTS = 'ACTION_REQUIRED_EMPLOYMENTS',
  JOB_REQUESTS = 'JOB_REQUESTS',
}
